import { reducedStream, reducer } from '@ardoq/rxbeach';
import { surveyPaneOperations } from './surveyPaneOperations';
import { setSurveyPaneData } from './actions';
import { SurveyPaneState } from './types';

const defaultState: SurveyPaneState = {
  component: null,
  survey: null,
};

export const surveyPane$ = reducedStream<SurveyPaneState>(
  'surveyPaneState',
  defaultState,
  [reducer(setSurveyPaneData, surveyPaneOperations.setSurveyPaneData)]
);
